import React, { useState, useEffect } from 'react'
import { useServices, components, constants } from 'cng-web-lib'
import DexpApiUrls from 'src/apiUrls/DexpApiUrls'
import moment from 'moment-timezone'

const {
  table: { useFetchCodeMaintenanceLookup },
} = components

const { filter: { EQUAL } } = constants

export const useTrackingService = () => {
  const { securedSendRequest } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const [lookups, setLookups] = useState(null)

  // Constants
  const CONSTANTS = {
    MOCK_1: ['CAMU9367871', '84531066ADB450'],
    MOCK_2: ['TGBU9367871', '91469367814352'],
    DEFAULT_DAYS_AT_PORT: 0,
    SIMULATION_DELAY: 1000,

    EVENT_SOURCES: {
      PSA: 'PSA',
      EHBL: 'EHBL',
      ACIOCN: 'ACIOCN',
      CUSTOMS_RELEASE: 'CUSTOMS_RELEASE'
    },

    EVENT_DESCRIPTIONS: {
      ACI_ACCEPTED: 'ACI_ACCEPTED',
      ACI_REJECTED: 'ACI_REJECTED',
      ACI_SUBMITTED: 'ACI_SUBMITTED',
      ACI_CANCELLED: 'ACI_CANCELLED',
      CUSTOMS_RELEASED: 'CUSTOMS_RELEASED',
      CUSTOMS_ARRIVED: 'CUSTOMS_ARRIVED',
      WAREHOUSE_ARRIV: 'WAREHOUSE_ARRIV',
      GATE_OUT_FULL: 'GATE_OUT_FULL',
      VESSEL_DISCHARGE: 'VESSEL_DISCHARGE',
      VESSEL_ATA: 'VESSEL_ATA',
      VESSEL_ATD: 'VESSEL_ATD',
      VESSEL_ETA: 'VESSEL_ETA',
      VESSEL_ETD: 'VESSEL_ETD',
      EXAM_COMPLETED: 'EXAM_COMPLETED',
      RAIL_DEPARTURE: 'RAIL_DEPARTURE'
    },

    EVENT_CODES: {
      CUSTOMS_RELEASED: '0013',
      CUSTOMS_ARRIVED: '8003',
      WAREHOUSE_ARRIVAL: '8001'
    },

    SUB_SOURCES: {
      HBL: 'HBL',
      CLMSG: 'CLMSG',
      VESSEL_SCHEDULE: 'VESSEL_SCHEDULE'
    }
  }

  const CAMU9367871MOCK = {
    "containerNumber": "CAMU9367871",
    "vesselName": "MSC SAO PAULO",
    "ccn": "84531066ADB450",
    "tripCycleId": 2945123,
    "ehblManifestId": 1589,
    "ehblHblId": 27114,
    "aciocnA6aId": 68211,
    "isActiveTrip": true,
    "dexpUnifiedEvent": [
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 912,
        "eventCode": null,
        "eventDescription": "4",
        "eventTime": "2026-03-26 18:20:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88055
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 1204,
        "eventCode": "0013",
        "eventDescription": "CUSTOMS_RELEASED",
        "eventTime": "2026-03-26 15:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 91004
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 1203,
        "eventCode": "8003",
        "eventDescription": "CUSTOMS_ARRIVED",
        "eventTime": "2026-03-26 13:45:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 91003
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 804,
        "eventCode": null,
        "eventDescription": "VESSEL_ETD",
        "eventTime": "2026-03-22 22:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "MSC SAO PAULO",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88021
      },
      {
        "sourceName": "PSA",
        "subSourceName": "ATLANTIC",
        "sourceEventId": 1202,
        "eventCode": null,
        "eventDescription": "RAIL_DEPARTURE",
        "eventTime": "2026-03-21 16:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "CAMU9367871",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 91002
      },
      {
        "sourceName": "PSA",
        "subSourceName": "ATLANTIC",
        "sourceEventId": 802,
        "eventCode": null,
        "eventDescription": "VESSEL_DISCHARGE",
        "eventTime": "2026-03-20 17:15:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "CAMU9367871",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88031
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 801,
        "eventCode": null,
        "eventDescription": "VESSEL_ATA",
        "eventTime": "2026-03-20 10:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "MSC SAO PAULO",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88021
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 908,
        "eventCode": null,
        "eventDescription": "5",
        "eventTime": "2026-03-19 15:45:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88055
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 907,
        "eventCode": null,
        "eventDescription": "9",
        "eventTime": "2026-03-19 14:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88055
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 906,
        "eventCode": null,
        "eventDescription": "0001",
        "eventTime": "2026-03-19 13:15:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88055
      },
      {
        "sourceName": "IID",
        "subSourceName": "IID",
        "sourceEventId": 905,
        "eventCode": null,
        "eventDescription": "IID_SUBMITTED",
        "eventTime": "2026-03-19 12:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88058
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 800,
        "eventCode": null,
        "eventDescription": "VESSEL_ETA",
        "eventTime": "2026-03-18 18:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "MSC SAO PAULO",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88021
      },
      {
        "sourceName": "EHBL",
        "subSourceName": "HBL",
        "sourceEventId": 904,
        "eventCode": null,
        "eventDescription": "ACI_ACCEPTED",
        "eventTime": "2026-03-15 13:45:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "84531066ADB450",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 88057
      }
    ],
    "complianceSummary": {
      "master_level": {
        "total_primary_ccns": 2,
        "status_breakdown": [
          {
              "count": 2,
              "ui_label": "Accepted",
              "internal_enum": "ACI_ACCEPTED"
          },
          {
              "count": 0,
              "ui_label": "Submitted",
              "internal_enum": "ACI_SUBMITTED"
          },
          {
              "count": 0,
              "ui_label": "Rejected",
              "internal_enum": "ACI_REJECTED"
          }
        ]
      },
      "house_level": {
        "total_ehbls": 5,
        "status_breakdown": [
          {
              "count": 5,
              "ui_label": "Accepted",
              "internal_enum": "ACI_ACCEPTED"
          },
          {
              "count": 0,
              "ui_label": "Submitted",
              "internal_enum": "ACI_SUBMITTED"
          },
          {
              "count": 0,
              "ui_label": "Rejected",
              "internal_enum": "ACI_REJECTED"
          },
          {
              "count": 0,
              "ui_label": "Released",
              "internal_enum": "CUSTOMS_RELEASED"
          },
          {
              "count": 0,
              "ui_label": "Held",
              "internal_enum": "CUSTOMS_HOLD"
          }
        ]
      }
    }
  };

  const TGBU9367871MOCK = {
    "containerNumber": "TGBU9367871",
    "vesselName": "ZIM FELIXSTOWE",
    "ccn": "91469367814352",
    "tripCycleId": 3057811,
    "ehblManifestId": 1692,
    "ehblHblId": 28941,
    "aciocnA6aId": 70188,
    "isActiveTrip": true,
    "dexpUnifiedEvent": [
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 1012,
        "eventCode": null,
        "eventDescription": "4",
        "eventTime": "2026-03-26 13:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99055
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 1104,
        "eventCode": null,
        "eventDescription": "VESSEL_ETD",
        "eventTime": "2026-03-22 14:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "ZIM FELIXSTOWE",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99021
      },
      {
        "sourceName": "PSA",
        "subSourceName": "ATLANTIC",
        "sourceEventId": 1103,
        "eventCode": null,
        "eventDescription": "RAIL_DEPARTURE",
        "eventTime": "2026-03-21 10:15:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "TGBU9367871",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99031
      },
      {
        "sourceName": "PSA",
        "subSourceName": "ATLANTIC",
        "sourceEventId": 1102,
        "eventCode": null,
        "eventDescription": "VESSEL_DISCHARGE",
        "eventTime": "2026-03-20 15:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "TGBU9367871",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99031
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 1101,
        "eventCode": null,
        "eventDescription": "VESSEL_ATA",
        "eventTime": "2026-03-20 11:45:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "ZIM FELIXSTOWE",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99021
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 1008,
        "eventCode": null,
        "eventDescription": "9",
        "eventTime": "2026-03-19 17:20:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99055
      },
      {
        "sourceName": "CUSTOMS_RELEASE",
        "subSourceName": "D4NOTICE",
        "sourceEventId": 1007,
        "eventCode": null,
        "eventDescription": "0001",
        "eventTime": "2026-03-19 15:45:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99055
      },
      {
        "sourceName": "IID",
        "subSourceName": "IID",
        "sourceEventId": 1006,
        "eventCode": null,
        "eventDescription": "IID_SUBMITTED",
        "eventTime": "2026-03-19 14:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99058
      },
      {
        "sourceName": "PSA",
        "subSourceName": "VESSEL_SCHEDULE",
        "sourceEventId": 1100,
        "eventCode": null,
        "eventDescription": "VESSEL_ETA",
        "eventTime": "2026-03-18 12:00:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "ZIM FELIXSTOWE",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99021
      },
      {
        "sourceName": "ACIOCN",
        "subSourceName": "A6A",
        "sourceEventId": 1005,
        "eventCode": null,
        "eventDescription": "ACI_ACCEPTED",
        "eventTime": "2026-03-15 15:30:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99060
      },
      {
        "sourceName": "ACIOCN",
        "subSourceName": "A6A",
        "sourceEventId": 1004,
        "eventCode": null,
        "eventDescription": "ACI_REJECTED",
        "eventTime": "2026-03-15 14:05:00.000000",
        "isRemoved": false,
        "removedDate": null,
        "sourceReferenceNo": "91469367814352",
        "messageFunction": null,
        "dexpUnifiedHeader": null,
        "unifiedHeaderId": 99060
      }
    ],
    "complianceSummary": {
      "master_level": {
        "total_primary_ccns": 2,
        "status_breakdown": [
          {
              "count": 2,
              "ui_label": "Accepted",
              "internal_enum": "ACI_ACCEPTED"
          },
          {
              "count": 0,
              "ui_label": "Submitted",
              "internal_enum": "ACI_SUBMITTED"
          },
          {
              "count": 0,
              "ui_label": "Rejected",
              "internal_enum": "ACI_REJECTED"
          }
        ]
      },
      "house_level": {
        "total_ehbls": 5,
        "status_breakdown": [
          {
              "count": 4,
              "ui_label": "Accepted",
              "internal_enum": "ACI_ACCEPTED"
          },
          {
              "count": 0,
              "ui_label": "Submitted",
              "internal_enum": "ACI_SUBMITTED"
          },
          {
              "count": 1,
              "ui_label": "Rejected",
              "internal_enum": "ACI_REJECTED"
          },
          {
              "count": 0,
              "ui_label": "Released",
              "internal_enum": "CUSTOMS_RELEASED"
          },
          {
              "count": 0,
              "ui_label": "Held",
              "internal_enum": "CUSTOMS_HOLD"
          }
        ]
      }
    }
  };

  // Color mapping (separate from DEXP_MAPPING lookup titles)
  const eventColorMap = {
    VESSEL_ETA: '#1976d2',
    VESSEL_ATA: '#4caf50',
    VESSEL_ETD: '#1976d2',
    VESSEL_ATD: '#4caf50',
    VESSEL_DISCHARGE: '#1976d2',

    RAIL_DEPARTURE: '#1976d2',
    INTERMODAL_MOVE: '#1976d2',
    GATE_OUT_FULL: '#4caf50',

    IID_SUBMITTED: '#ff9800',
    ACI_SUBMITTED: '#ff9800',
    ACI_ACCEPTED: '#1976d2',
    ACI_REJECTED: '#f44336',
    ACI_CANCELLED: '#757575',

    CUSTOMS_RELEASED: '#4caf50',
    CUSTOMS_ARRIVED: '#4caf50',
    CUSTOMS_HOLD: '#f44336',
    CUSTOMS_EXAM: '#f44336',
    CARGO_COMPLETE: '#1976d2',
    CBSA_REPORTED: '#1976d2',

    CFIA_REFERRAL: '#ff9800',
    DOC_MISSING: '#ff9800',
    MANIFEST_MISMATCH: '#ff9800',

    WAREHOUSE_ARRIV: '#1976d2',
    EXAM_COMPLETED: '#d7d53a',

    DECONSOL_START: '#1976d2',
    1: '#4caf50',
    4: '#4caf50',
    5: '#f44336',
    8: '#ff9800',
    9: '#1976d2',
    14: '#f44336',
    34: '#1976d2',
    128: '#ff9800',
    '0001': '#4caf50',
    '0002': '#ff9800',
    '0005': '#ff9800',
    '0040': '#4caf50',
    '0041': '#ff9800',
    '0007': '#4caf50'
  }

  const getEventColor = (eventDescription) => eventColorMap[eventDescription] || '#757575'

  const getMappedTitle = (eventDescription) =>
    getLookupValue('dexpMappingData', eventDescription) || eventDescription

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  useEffect(() => {
    if (!fetchCodeMaintenanceLookup) return

    Promise.all([
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'DEXP_EVENT_MAPPING' }],
        undefined,
        'code'
      )
    ]).then(([dexpMappingData]) => {
      setLookups({ dexpMappingData })
    }).catch((err) => {
      console.error('Failed to fetch code maintenance lookup:', err)
    })

  }, [])

  // Utility functions
  const toEasternMoment = (dateTimeString) => {
    // Preserve any timezone/offset from the backend (e.g., "+0800" or "Z"), then convert for display/sorting
    return moment.parseZone(dateTimeString).tz('Canada/Eastern')
  }

  const compareEventTimes = (eventA, eventB, reverse = true) => {
    const momentA = toEasternMoment(eventA.eventTime)
    const momentB = toEasternMoment(eventB.eventTime)

    // reverse=true means latest first (default), reverse=false means oldest first
    return reverse ? momentB.diff(momentA) : momentA.diff(momentB)
  }

  const formatDateTime = (dateTimeString) => {
    const eventMoment = toEasternMoment(dateTimeString)

    return {
      date: eventMoment.format('MMM D'), // e.g., "Jan 23"
      time: eventMoment.format('h:mm A'), // e.g., "8:03 AM"
      fullTime: eventMoment.format('MMM D, h:mm A'), // e.g., "Jan 23, 8:03 AM"
      sortTime: eventMoment.valueOf() // milliseconds since epoch (Eastern-adjusted)
    }
  }

  const getEventLocation = (event) => {
    const { sourceName, subSourceName, eventDescription, sourceReferenceNo } = event

    if (sourceName === CONSTANTS.EVENT_SOURCES.PSA) {
      if (eventDescription.includes('VESSEL')) {
        return `Halifax Port • ${sourceReferenceNo}`
      }
      // Remove separators and capitalize each word
      const formattedSubSource = subSourceName
        ?.split(/[_\-\s]+/) // Split on underscore, dash, or space
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
      return `PSA Halifax (${formattedSubSource} Hub)`
    }

    if ([CONSTANTS.EVENT_SOURCES.CUSTOMS_RELEASE,
    CONSTANTS.EVENT_SOURCES.EHBL,
    CONSTANTS.EVENT_SOURCES.ACIOCN].includes(sourceName)) {
      return 'Customs'
    }

    return ''
  }

  const isAciEvent = (event) => {
    return [CONSTANTS.EVENT_DESCRIPTIONS.ACI_ACCEPTED,
    CONSTANTS.EVENT_DESCRIPTIONS.ACI_REJECTED,
    CONSTANTS.EVENT_DESCRIPTIONS.ACI_CANCELLED,
    CONSTANTS.EVENT_DESCRIPTIONS.ACI_SUBMITTED].includes(event.eventDescription)
  }

  // Event grouping functions
  const groupEventsBySource = (events) => {
    const activeEvents = events.filter(event => !event.isRemoved)

    return {
      ehbl: activeEvents.filter(event =>
        event.sourceName === CONSTANTS.EVENT_SOURCES.EHBL && isAciEvent(event)
      ),
      aciocn: activeEvents.filter(event =>
        event.sourceName === CONSTANTS.EVENT_SOURCES.ACIOCN && isAciEvent(event)
      ),
      customs: activeEvents.filter(event =>
        event.sourceName === CONSTANTS.EVENT_SOURCES.CUSTOMS_RELEASE
      ),
      other: activeEvents.filter(event =>
        !(event.sourceName === CONSTANTS.EVENT_SOURCES.EHBL && isAciEvent(event)) &&
        !(event.sourceName === CONSTANTS.EVENT_SOURCES.ACIOCN && isAciEvent(event)) &&
        event.sourceName != CONSTANTS.EVENT_SOURCES.CUSTOMS_RELEASE
      )
    }
  }

  const createSubEvent = (event, isLatest) => {
    const { fullTime } = formatDateTime(event.eventTime)

    const getSubEventTitle = (event) => {
      if (event.sourceName === CONSTANTS.EVENT_SOURCES.EHBL) {
        const prefix = event.subSourceName === CONSTANTS.SUB_SOURCES.CLMSG ? 'Close Message' : 'eHBL'
        // Use mapped DEXP titles for manifest status text
        return `${prefix} ${getMappedTitle(event.eventDescription)}`
      }

      if (event.sourceName === CONSTANTS.EVENT_SOURCES.ACIOCN) {
        // Use mapped DEXP titles (e.g., Manifest Accepted/Rejected/Submitted/Cancelled)
        return `ACI ${getMappedTitle(event.eventDescription)}`
      }

      // Customs/PSA/etc: use mapped title
      return getMappedTitle(event.eventDescription)
    }

    const isHighlighted = (event) => {
      return event.eventCode === CONSTANTS.EVENT_CODES.CUSTOMS_ARRIVED &&
        event.eventDescription === CONSTANTS.EVENT_DESCRIPTIONS.CUSTOMS_ARRIVED
    }

    return {
      title: getSubEventTitle(event),
      time: fullTime,
      highlight: isLatest, //isHighlighted(event),
      bold: isLatest, //isHighlighted(event) || isLatest
    }
  }

  // Helper function to generate event titles consistently
  const getEventTitle = (event, groupType) => {
    if (groupType === 'ehbl') {
      const prefix = event.subSourceName === CONSTANTS.SUB_SOURCES.CLMSG ? 'Close Message' : 'eHBL'
      return getLookupValue('dexpMappingData', event.eventDescription)
        ? `${prefix} ${getLookupValue('dexpMappingData', event.eventDescription)}`
        : event.eventDescription;
    }

    // Use lookup for ACIOCN group
    if (groupType === 'aciocn') {
      return 'ACI ' + getLookupValue('dexpMappingData', event.eventDescription)
    }

    if (groupType === 'customs') {
      return getMappedTitle(event.eventDescription)
    }

    return event.eventDescription
  }

  const createGroupedEvent = (events, groupType) => {
    if (!events.length) return null

    // Sort events by time (latest first)
    const sortedEvents = [...events].sort((a, b) => compareEventTimes(a, b))

    // For ACI/EHBL/Customs events: only group if there are multiple events
    // Single Event if only 1
    if ((groupType === 'aciocn' || groupType === 'ehbl' || groupType === 'customs') && sortedEvents.length === 1) {
      // Return as individual event, not grouped
      const event = sortedEvents[0]

      const { date, time, sortTime } = formatDateTime(event.eventTime)
      const title = getEventTitle(event, groupType)

      return {
        id: `individual-${groupType}-${event.sourceEventId}`,
        date,
        time,
        sortTime,
        title,
        location: 'Customs',
        color: getEventColor(event.eventDescription),
        expandable: false
      }
    }

    const latestEvent = sortedEvents[0]
    const { date, time, sortTime } = formatDateTime(latestEvent.eventTime)

    let subEventsList = sortedEvents
    // if (groupType === 'customs') {
    //   subEventsList = sortedEvents.filter(event =>
    //     !(event.eventCode === CONSTANTS.EVENT_CODES.CUSTOMS_RELEASED &&
    //       event.eventDescription === CONSTANTS.EVENT_DESCRIPTIONS.CUSTOMS_RELEASED)
    //   )
    // }

    const latestSubEventTime = subEventsList.length
      ? toEasternMoment(subEventsList[0].eventTime).valueOf()
      : null

    const subEvents = subEventsList
      .map((event) => createSubEvent(
        event,
        latestSubEventTime !== null && toEasternMoment(event.eventTime).valueOf() === latestSubEventTime
      ))
      .filter(subEvent => subEvent !== null) // Filter out null results

    return {
      id: `${groupType}-manifest`,
      date,
      time,
      sortTime,
      title: getEventTitle(latestEvent, groupType),
      location: 'Customs',
      color: getEventColor(latestEvent.eventDescription),
      expandable: groupType === 'customs' ? subEventsList.length > 0 : true,
      subEvents: groupType === 'customs' && subEventsList.length === 0 ? undefined : subEvents
    }
  }

  const processIndividualEvents = (events) => {
    return events.map((event, index) => {

      const { date, time, sortTime } = formatDateTime(event.eventTime)

      return {
        id: `event-${event.sourceEventId}-${index}`,
        date,
        time,
        sortTime,
        title: getMappedTitle(event.eventDescription),
        location: getEventLocation(event),
        color: getEventColor(event.eventDescription)
      }
    })
  }

  const processSupersededEvents = (events) => {
    return events
      .filter(event => event.isRemoved)
      .map((event, index) => {

        const { date, time, sortTime } = formatDateTime(event.eventTime)

        return {
          id: `superseded-${event.sourceEventId}-${index}`,
          date,
          time: '',
          sortTime,
          title: `${getMappedTitle(event.eventDescription)} (Superseded)`,
          location: `Original ETA: ${date}, ${time}`,
          status: 'superseded',
          color: '#bdbdbd'
        }
      })
  }

  const buildNoEventsPayload = (overrides = {}) => ({
    status: 'No events found',
    containerNumber: undefined,
    vesselName: undefined,
    daysAtPort: CONSTANTS.DEFAULT_DAYS_AT_PORT,
    events: [],
    noEventsFound: true,
    ...overrides
  })

  const normalizeApiRows = (response) => {
    const rows = response?.data
    return Array.isArray(rows) ? rows : []
  }

  const calculateDaysAtPort = (events) => {
    const activeEvents = Array.isArray(events) ? events.filter((e) => !e.isRemoved) : []

    const discharge = activeEvents
      .filter((e) => e.eventDescription === CONSTANTS.EVENT_DESCRIPTIONS.VESSEL_DISCHARGE)
      .sort((a, b) => compareEventTimes(a, b, false))[0] // oldest discharge

    if (!discharge?.eventTime) return CONSTANTS.DEFAULT_DAYS_AT_PORT

    //gate out and rail departure also consider as gate out
    const gateOut = activeEvents
      .filter((e) => (e.eventDescription === CONSTANTS.EVENT_DESCRIPTIONS.GATE_OUT_FULL || e.eventDescription === CONSTANTS.EVENT_DESCRIPTIONS.RAIL_DEPARTURE))
      .sort((a, b) => compareEventTimes(a, b))[0] // latest gate out

    const start = toEasternMoment(discharge.eventTime)
    const end = gateOut?.eventTime
      ? toEasternMoment(gateOut.eventTime)
      : moment.tz('Canada/Eastern')

    const ms = end.diff(start)
    let days = ms / (1000 * 60 * 60 * 24)
    return Math.ceil(days)
  }

  // Container-number processing (backend already returns physical-only events)
  const processContainerTrackingData = (rawData) => {
    if (!rawData?.dexpUnifiedEvent) return rawData

    const events = Array.isArray(rawData.dexpUnifiedEvent) ? rawData.dexpUnifiedEvent : []
    const activeEvents = events.filter((e) => (!e.isRemoved && e.subSourceName !== 'VESSEL_SCHEDULE') || (e.subSourceName === 'VESSEL_SCHEDULE'))

    // // Container-number UI: only show these physical statuses
    // const containerLocationHeaderStatus = new Set([ //how to now got what physical status?
    //   CONSTANTS.EVENT_DESCRIPTIONS.VESSEL_DISCHARGE,
    //   CONSTANTS.EVENT_DESCRIPTIONS.GATE_OUT_FULL
    // ])

    const physicalEvents = activeEvents
      .sort((a, b) => compareEventTimes(a, b)) // Latest first

    if (physicalEvents.length === 0) {
      return buildNoEventsPayload({
        containerNumber: rawData.containerNumber,
        vesselName: rawData.vesselName,
        daysAtPort: rawData.daysAtPort || CONSTANTS.DEFAULT_DAYS_AT_PORT
      })
    }


    const processedEvents = physicalEvents.map((event, index) => {
      const { date, time, sortTime } = formatDateTime(event.eventTime)

      if (event.isRemoved && event.subSourceName === 'VESSEL_SCHEDULE') {
        return {
          id: `superseded-${event.sourceEventId}-${index}`,
          date,
          time: '',
          sortTime,
          title: `${getMappedTitle(event.eventDescription)} (Superseded)`,
          location: `Original ETA: ${date}, ${time}`,
          status: 'superseded',
          color: '#bdbdbd'
        }
      }

      return {
        id: `physical-${event.sourceEventId}-${index}`,
        date,
        time,
        sortTime,
        title: getMappedTitle(event.eventDescription),
        location: getEventLocation(event),
        color: getEventColor(event.eventDescription)
      }
    })

    return {
      // Header should reflect the latest physical status being tracked (latest eventTime)
      status: processedEvents[0]?.title,
      containerNumber: rawData.containerNumber,
      vesselName: rawData.vesselName,
      daysAtPort: calculateDaysAtPort(rawData.dexpUnifiedEvent),
      events: processedEvents,
      complianceSummary: rawData.complianceSummary
    }
  }

  const getRegulatoryHeaderStatus = (rawData) => {
    const events = Array.isArray(rawData?.dexpUnifiedEvent) ? rawData.dexpUnifiedEvent : []

    const regulatorySources = new Set([
      CONSTANTS.EVENT_SOURCES.CUSTOMS_RELEASE,
      CONSTANTS.EVENT_SOURCES.EHBL,
      CONSTANTS.EVENT_SOURCES.ACIOCN,
      CONSTANTS.EVENT_SOURCES.PSA
    ])

    const regulatoryEvents = events
      .filter((e) => !e.isRemoved)
      .filter((e) => regulatorySources.has(e.sourceName))

    if (regulatoryEvents.length === 0) return undefined

    // Latest regulatory event
    const latest = regulatoryEvents.sort((a, b) => compareEventTimes(a, b))[0]

    // Friendly title:
    if (latest.sourceName === CONSTANTS.EVENT_SOURCES.CUSTOMS_RELEASE || latest.sourceName === CONSTANTS.EVENT_SOURCES.PSA) {
      return getMappedTitle(latest.eventDescription)
    }

    if (latest.sourceName === CONSTANTS.EVENT_SOURCES.EHBL) {
      return getEventTitle(latest, 'ehbl')
    }

    if (latest.sourceName === CONSTANTS.EVENT_SOURCES.ACIOCN) {
      return getEventTitle(latest, 'aciocn')
    }

    return latest.eventDescription
  }

  // Main processing function
  const processTrackingData = (rawData) => {
    if (!rawData?.dexpUnifiedEvent) {
      return rawData
    }
    // When no events found case
    if (Array.isArray(rawData.dexpUnifiedEvent) && rawData.dexpUnifiedEvent.length === 0) {
      return {
        status: 'No events found',
        containerNumber: rawData.containerNumber,
        vesselName: rawData.vesselName,
        daysAtPort: rawData.daysAtPort || CONSTANTS.DEFAULT_DAYS_AT_PORT,
        events: [],
        noEventsFound: true
      }
    }

    const { ehbl, aciocn, customs, other } = groupEventsBySource(rawData.dexpUnifiedEvent)

    const processedEvents = []

    // Process individual events
    processedEvents.push(...processIndividualEvents(other))

    // Process grouped events
    const ehblGroup = createGroupedEvent(ehbl, 'ehbl')
    const aciocnGroup = createGroupedEvent(aciocn, 'aciocn')
    const customsGroup = createGroupedEvent(customs, 'customs')

    if (ehblGroup) processedEvents.push(ehblGroup)
    if (aciocnGroup) processedEvents.push(aciocnGroup)
    if (customsGroup) processedEvents.push(customsGroup)

    // Process superseded events
    const supersededEvents = processSupersededEvents(rawData.dexpUnifiedEvent)

    // Build final response
    const headerStatus = getRegulatoryHeaderStatus(rawData)

    return {
      status: headerStatus || rawData.status || 'No events found',
      containerNumber: rawData.containerNumber,
      vesselName: rawData.vesselName,
      daysAtPort: calculateDaysAtPort(rawData.dexpUnifiedEvent),
      events: [...processedEvents, ...supersededEvents]
    }
  }

  // API functions
  const trackCcn = async (ccn) => {
    const formData = new FormData()
    formData.append('ccn', ccn)

    const noEventsPayload = buildNoEventsPayload()

    return new Promise((resolve, reject) => {
      try {
        securedSendRequest.execute(
          'POST',
          DexpApiUrls.TRACK_CCN,
          formData,
          (response) => {
            try {
              const rows = normalizeApiRows(response)
              if (rows.length === 0) {
                resolve(noEventsPayload)
                return
              }

              const processedData = processTrackingData(rows[0])
              // If after processing there are no events, still return empty-state payload
              if (!processedData?.events || processedData.events.length === 0) {
                resolve({ ...noEventsPayload, ...processedData })
                return
              }

              resolve(processedData)
            } catch (err) {
              reject(err)
            }
          },
          (error) => {
            const status = error?.response?.status ?? error?.status
            // Treat not-found/no-content as empty result
            if (status === 404 || status === 204) {
              resolve(noEventsPayload)
              return
            }
            reject(error)
          }
        )
      } catch (err) {
        reject(err)
      }
    })
  }

  const trackContainer = async (containerNumber) => {
    const formData = new FormData()
    formData.append('containerNumber', containerNumber)

    const noEventsPayload = buildNoEventsPayload()

    return new Promise((resolve, reject) => {
      try {
        securedSendRequest.execute(
          'POST',
          DexpApiUrls.TRACK,
          formData,
          (response) => {
            try {
              const rows = normalizeApiRows(response)
              if (rows.length === 0) {
                resolve(noEventsPayload)
                return
              }

              const processedData = processContainerTrackingData(rows[0])
              if (!processedData?.events || processedData.events.length === 0) {
                resolve({ ...noEventsPayload, ...processedData })
                return
              }

              resolve(processedData)
            } catch (err) {
              reject(err)
            }
          },
          (error) => {
            const status = error?.response?.status ?? error?.status
            if (status === 404 || status === 204) {
              resolve(noEventsPayload)
              return
            }
            reject(error)
          }
        )
      } catch (err) {
        reject(err)
      }
    })
  }

  const unifiedTracking = async (searchInput, trackingType = 'CONTAINER') => {
    if (!searchInput) {
      return buildNoEventsPayload()
    }

    // Check for mock data first
    const isMockData =  CONSTANTS.MOCK_1.includes(searchInput.toUpperCase()) || CONSTANTS.MOCK_2.includes(searchInput.toUpperCase())

    if (isMockData) {
      return new Promise((resolve) => {
        let processedData
        let mockDataBase = {'dexpUnifiedEvent': []}

        // For mock container tracking, restrict to PSA events only
        if (trackingType === 'CONTAINER') {
          if(searchInput.toUpperCase() === 'CAMU9367871'){
            mockDataBase = CAMU9367871MOCK
          }
          if(searchInput.toUpperCase() === 'TGBU9367871'){
            mockDataBase = TGBU9367871MOCK
          }
          let mockData = mockDataBase
          const filteredEvents = Array.isArray(mockDataBase?.dexpUnifiedEvent)
            ? mockDataBase.dexpUnifiedEvent.filter(e => e?.sourceName === CONSTANTS.EVENT_SOURCES.PSA)
            : []
          mockData = { ...mockDataBase, dexpUnifiedEvent: filteredEvents }
          processedData = processContainerTrackingData(mockData)
        }else{
          if(searchInput.toUpperCase() === '84531066ADB450'){
            mockDataBase = CAMU9367871MOCK
          }
          if(searchInput.toUpperCase() === '91469367814352'){
            mockDataBase = TGBU9367871MOCK
          }
          processedData = processTrackingData(mockDataBase)
        }
        setTimeout(() => resolve(processedData), CONSTANTS.SIMULATION_DELAY)
      })
    }

    // Handle CCN search
    if (trackingType === 'CCN') {
      return trackCcn(searchInput)
    }

    if (trackingType === 'CONTAINER') {
      return trackContainer(searchInput)
    }

    return buildNoEventsPayload()
  }

  return {
    unifiedTracking
  }
}
